/*
 * @Author: cmchiu
 * @Date: 2022-09-02 17:38:29
 * @LastEditTime: 2023-01-11 15:23:59
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\router\routes.js
 *
 */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    {
        path: '/',
        component: Layout,
        name: '_home',
        redirect: '/courselist',
        children: [
            {
                path: 'courselist',
                name: 'CourseList',
                component: () => import('@/views/CourseList'),
                meta: { title: '學習市集', icon: 'el-icon-s-home' },
            },
        ],
    },
    {
        path: '/',
        component: Layout,
        redirect: '/coursebook',
        children: [
            {
                path: 'coursebook',
                name: 'CourseBook',
                component: () => import('@/views/CourseBook'),
                meta: { title: '課程預約' },
            },
        ],
    },
    /* {
        path: '/',
        component: Layout,
        meta: { title: '我的課程' },
        redirect: '/mycourse',
        children: [
            {
                path: 'mycourse',
                name: 'MyCourse',
                component: () => import('@/views/MyCourse'),
            },
        ],
    }, */
    /* {
        path: '/',
        component: Layout,
        meta: { title: '開課需求調查' },
        redirect: '/coursedemand',
        children: [
            {
                path: 'coursedemand',
                name: 'CourseDemand',
                component: () => import('@/views/CourseDemand'),
            },
        ],
    }, */
    /* {
        path: '/404',
        name: 'error_404',
        meta: {
            hideInMenu: true,
            keepAlive: true,
        },
        component: () => import('@/views/error-page/404.vue'),
    }, */
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
    /* {
        path: '/alumni',
        // component: Layout,
        name: 'alumni',
        beforeEnter: () => {
            window.location.href = '//campus2.sce.pccu.edu.tw/alumni/'
        },
    }, */
]

export default [...constantRoutes, ...asyncRoutes]
